import { styled } from '@mui/material/styles';

import {
    PromoColors,
    promoPalette,
    Theme,
    calculateRebrandingSize,
    rem,
} from '../../theme';

interface StyledCardProperties {
    $paletteColor: PromoColors;
    $squeeze?: boolean;
}

export const StyledCard = styled('div')<StyledCardProperties>`
    ${({ theme }) => theme.typography.text_10_desktop_14};
    ${({
        theme,
        $squeeze,
        $paletteColor,
    }: StyledCardProperties & {
        theme: Theme;
    }) => `
        position: absolute;
        top: ${theme.tggSpacing(calculateRebrandingSize(0, 0))};
        display: flex;
        gap: ${theme.tggSpacing(calculateRebrandingSize(rem(0.5), 2))};
        align-items: center;
        padding: ${theme.tggSpacing(calculateRebrandingSize([rem(0.4), rem(1)], [1.5, 4]))};
        color: ${promoPalette[$paletteColor].text};
        background-color: ${promoPalette[$paletteColor].background};
        border-radius: ${theme.tggSpacing(calculateRebrandingSize(rem(1), 4))};
        transform: translateY(-50%);
       
        ${theme.breakpoints.up('desktop')} {
            padding: ${theme.tggSpacing(calculateRebrandingSize([rem(0.6), rem(1), rem(0.5)], [2.4, 4, 2]))};
        }

        ${theme.breakpoints.down(468)} {
            svg {
                flex: 1;
            }

            b {
                flex: 2;
                white-space: nowrap;
            }

            ${
                $squeeze
                    ? `
                left: 0;

                b {
                    white-space: wrap;
                }
            `
                    : ''
            }
        }
    `}
`;
